import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json'

const mediaQueries = {
  fromlarge: `(min-width: ${tokens.viewports.breakpoints.large})`,
  frommedium: `(min-width: ${tokens.viewports.breakpoints.medium})`,
  fromsmall: `(min-width: ${tokens.viewports.breakpoints.small})`,
  fromxsmall: `(min-width: ${tokens.viewports.breakpoints.xsmall})`,
  fromxxsmall: `(min-width: ${tokens.viewports.breakpoints.xxsmall})`,
}

export default mediaQueries
